import React from "react";
import { motion } from "framer-motion";
import "./IntroAboutUs.css";
import aboutImage from "../../assets/images/im2.jpg";

export default function IntroAboutUs() {
  return (
    <section className="about-section_ed44">
      <motion.div
        className="about-bg_ed44"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2 }}
      ></motion.div>

      <div className="about-content_ed44">
        {/* Left - Text Content */}
        <motion.div 
          className="about-text_ed44"
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <h1 className="about-heading_ed44">
            Redefining <span className="highlight">Possibilities</span>
          </h1>
          <p className="about-subheading_ed44">
            Where Innovation Meets Excellence
          </p>
          <p className="about-description_ed44">
            At <strong>SARS India Liaison Pvt. Ltd. </strong>, we push boundaries, disrupt norms, and empower  
            businesses to thrive in an ever-evolving world. Our expertise in Industrial Statutory  
            compliance, strategic advisory, and Engineering transformation makes us the  
            trusted partner for industry leaders.
          </p>
          <p className="about-description_ed44">
            We embrace the future with **cutting-edge solutions**, ensuring seamless integration  
            of technology, compliance, and business intelligence. Step into a world of innovation.
          </p>
        </motion.div>

        {/* Right - Image */}
        <motion.div 
          className="about-image_ed44"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
        >
          <img src={aboutImage} alt="Innovation at SARS India" className="image_ed44" />
        </motion.div>
      </div>
    </section>
  );
}
